import React from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import TabBarIcon from "../components/TabBarIcon";
import HomeScreen from "../screens/HomeScreen";
import LoginScreen from "../screens/LoginScreen";
import ForgotPasswordScreen from "../screens/ForgotPasswordScreen.js";
import RegisterScreen from "../screens/RegisterScreen";
import ArticleListScreen from "../screens/ArticleListScreen";
import ChangePasswordScreen from "../screens/ChangePasswordScreen";
import SubscribeNewsletter from "../screens/SubscribeNewsletter.js";
import InformationScreen from "../screens/InformationScreen.js";
import { TransitionPresets } from "@react-navigation/stack";
import { AppDataContext } from "../context/AppDataProvider.js";
import WebWelcomeScreen from "../screens/WebWelcomeScreen";

const BottomTab = createBottomTabNavigator();
const INITIAL_ROUTE_NAME = "HomeScreen";

export default function BottomTabNavigator({
  setCategory,
  articleId,
  userId,
  myUserSettings,
  authToken,
  setAuthToken,
  handleLogout,
  userDetails,
}) {
  const { isLoggedIn, setLoggedIn, colors, isDarkMode, isForceLogin } =
    React.useContext(AppDataContext);

  React.useEffect(() => {
    if (myUserSettings) {
      var dataSideColour = myUserSettings.find(
        (az) =>
          az.id > 0 && az.setting && az.setting.description === "App Dark Mode"
      );
      if (dataSideColour) {
        setScheme(dataSideColour.rawValue);
      }
    }
  }, [myUserSettings]);

  function mainScreens() {
    return (
      <React.Fragment>
        <BottomTab.Screen
          name="WelcomeScreen"
          options={{
            title: "WelcomeScreen",
            tabBarIcon: ({ focused }) => (
              <TabBarIcon focused={focused} name="md-infinite" />
            ),
            title: "Welcome",
            ...TransitionPresets.ModalSlideFromBottomIOS,
          }}
        >
          {(props) => (
            <WebWelcomeScreen
              {...props}
              authToken={authToken}
              setCategory={setCategory}
              userDetails={userDetails}
            />
          )}
        </BottomTab.Screen>
        <BottomTab.Screen
          name="ArticleList"
          options={{
            title: "ArticleList",
            tabBarIcon: ({ focused }) => (
              <TabBarIcon focused={focused} name="md-infinite" />
            ),
            title: "Profile",
            ...TransitionPresets.ModalSlideFromBottomIOS,
          }}
        >
          {(props) => (
            <ArticleListScreen
              {...props}
              authToken={authToken}
              setCategory={setCategory}
              userDetails={userDetails}
            />
          )}
        </BottomTab.Screen>
        <BottomTab.Screen
          name="ChangePassword"
          options={{
            title: "ChangePassword",
            tabBarIcon: ({ focused }) => (
              <TabBarIcon focused={focused} name="md-pulse" />
            ),
          }}
        >
          {(props) => (
            <ChangePasswordScreen
              {...props}
              authToken={authToken}
              userId={userId}
              myUserSettings={myUserSettings}
              setCategory={setCategory}
              handleLogout={handleLogout}
              userDetails={userDetails}
              authToken={authToken}
            />
          )}
        </BottomTab.Screen>
        <BottomTab.Screen
          name="SubscribeNewsletter"
          options={{
            title: "SubscribeNewsletter",
            tabBarIcon: ({ focused }) => (
              <TabBarIcon focused={focused} name="md-pulse" />
            ),
          }}
        >
          {(props) => (
            <SubscribeNewsletter
              {...props}
              authToken={authToken}
              userId={userId}
              myUserSettings={myUserSettings}
              setCategory={setCategory}
              handleLogout={handleLogout}
              userDetails={userDetails}
              authToken={authToken}
            />
          )}
        </BottomTab.Screen>
        <BottomTab.Screen
          name="Information"
          options={{
            title: "Information",
            tabBarIcon: ({ focused }) => (
              <TabBarIcon focused={focused} name="md-settings" />
            ),
          }}
        >
          {(props) => <InformationScreen {...props} />}
        </BottomTab.Screen>
      </React.Fragment>
    );
  }

  function authScreens(showNavBar) {
    if (isLoggedIn) {
      return <></>;
    }
    return (
      <React.Fragment>
        <BottomTab.Screen
          name="Register"
          options={{
            title: "Register",
            tabBarIcon: ({ focused }) => (
              <TabBarIcon focused={focused} name="logo-game-controller-b" />
            ),
          }}
        >
          {(props) => (
            <RegisterScreen
              {...props}
              setAuthToken={setAuthToken}
              setLoggedIn={setLoggedIn}
              showNavBar={showNavBar}
            />
          )}
        </BottomTab.Screen>
        <BottomTab.Screen
          name="Login"
          options={{
            title: "Login",
            tabBarIcon: ({ focused }) => (
              <TabBarIcon focused={focused} name="md-person" />
            ),
          }}
        >
          {(props) => (
            <LoginScreen
              {...props}
              setAuthToken={setAuthToken}
              setLoggedIn={setLoggedIn}
              showNavBar={showNavBar}
            />
          )}
        </BottomTab.Screen>
        <BottomTab.Screen
          name="ForgotPassword"
          options={{
            title: "ForgotPassword",
            tabBarIcon: ({ focused }) => (
              <TabBarIcon focused={focused} name="md-person" />
            ),
          }}
        >
          {(props) => (
            <ForgotPasswordScreen
              {...props}
              setAuthToken={setAuthToken}
              setLoggedIn={setLoggedIn}
              showNavBar={showNavBar}
            />
          )}
        </BottomTab.Screen>
      </React.Fragment>
    );
  }

  if (isForceLogin) {
    /**
     * User needs to login to access the contents.
     */
    return (
      <BottomTab.Navigator
        screenOptions={{
          headerStyle: {
            backgroundColor: "#f4511e",
          },
          gestureEnabled: true,
          ...TransitionPresets.ModalPresentationIOS,
          headerShown: false,
          headerTintColor: "#fff",
          headerTitleStyle: {
            fontWeight: "bold",
          },
          tabBarStyle: {
            backgroundColor: isDarkMode ? colors.background : "#fff",
            border: "none",
            display: isLoggedIn ? "none" : "none",
            // for show, set to flex instead of none.
          },
        }}
        barStyle={{ backgroundColor: "#fff" }}
        initialRouteName={isLoggedIn ? "WebWelcomeScreen" : INITIAL_ROUTE_NAME}
        tabBarOptions={{
          showLabel: false,
          headerShown: false,
          tabBarStyle: {
            backgroundColor: isDarkMode ? colors.background : "#fff",
            border: "none",
            display: isLoggedIn ? "flex" : "none",
          },
        }}
      >
        {isLoggedIn ? (
          mainScreens()
        ) : (
          <React.Fragment>
            <BottomTab.Screen
              name="HomeScreen"
              options={{
                title: "HomeScreen",
                tabBarIcon: ({ focused }) => (
                  <TabBarIcon focused={focused} name="logo-game-controller-b" />
                ),
              }}
            >
              {(props) => (
                <HomeScreen
                  {...props}
                  authToken={authToken}
                  setLoggedIn={setLoggedIn}
                />
              )}
            </BottomTab.Screen>
            {authScreens(false)}
          </React.Fragment>
        )}
      </BottomTab.Navigator>
    );
  } else {
    return (
      <BottomTab.Navigator
        screenOptions={{
          headerStyle: {
            backgroundColor: "#f4511e",
          },
          gestureEnabled: true,
          ...TransitionPresets.ModalPresentationIOS,
          headerShown: false,
          headerTintColor: "#fff",
          headerTitleStyle: {
            fontWeight: "bold",
          },
          tabBarStyle: {
            backgroundColor: isDarkMode ? colors.background : "#fff",
            border: "none",
            display: isLoggedIn ? "none" : "none",
            // for show, set to flex instead of none.
          },
        }}
        barStyle={{ backgroundColor: "#fff" }}
        initialRouteName={isLoggedIn ? "ArticleListScreen" : INITIAL_ROUTE_NAME}
        tabBarOptions={{
          showLabel: false,
          headerShown: false,
          tabBarStyle: {
            backgroundColor: isDarkMode ? colors.background : "#fff",
            border: "none",
            display: isLoggedIn ? "flex" : "none",
          },
        }}
      >
        {mainScreens()}
        {authScreens(true)}
      </BottomTab.Navigator>
    );
  }
}
